
import { Component, Prop, Vue } from "vue-property-decorator";
import { JielongPreviewTab } from "@/api/jielong";

interface TabOption {
  label: string;
  value: JielongPreviewTab;
}

@Component
export default class PreviewAnchorTabs extends Vue {
  @Prop({ required: true }) activeTab!: JielongPreviewTab;

  readonly tabs: TabOption[] = [
    { label: "介绍", value: "intro" },
    { label: "商品", value: "goods" },
    { label: "接龙记录", value: "records" },
  ];
}
